module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p4-5.203c1b24.jpg";